export default "__VITE_ASSET__194db96b__"